module.exports = __webpack_public_path__ + "static/media/winding-forest-road.04e00d53.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/winding-forest-road.webm
// module id = 1701
// module chunks = 0